import styled, { css, keyframes } from 'styled-components';
import { Button } from '@simplywallst/ui-core';
import {
  PlusSolid,
  ShareOutline,
  EditSolid,
  NotesOutline,
} from '@simplywallst/ui-core/icons';

const easeOutCubic = 'cubic-bezier(0.23, 1, 0.32, 1)';

const show = (y: number) => keyframes`
  from          { transform: translate(0, 0); opacity: 0; }
  to            { transform: translate(0, calc(${-y}px)); opacity: 1; }
`;

const hide = (y: number) => keyframes`
  from          { transform: translate(0, calc(${-y}px)); opacity: 1; }
  to            { transform: translate(0, 0); opacity: 0; }
`;

export const Floating = styled('div')<{ isEnter: boolean }>`
  border: 0;
  z-index: 9998;
  position: fixed;
  vertical-align: top;
  text-decoration: none;
  right: max(calc(50vw - 600px - 72px), ${({ theme }) => theme.x2spacePx}px);
  bottom: ${({ theme }) => theme.safeAreaInsetBottom};
  ${({ theme, isEnter }) => {
    const goTo = isEnter ? show : hide;
    return css`
      animation: ${goTo(theme.x10spacePx)} 0.3s ${easeOutCubic} 0s forwards;
    `;
  }}
`;

export const FloatingActionMenu = styled('div')<{ isEnter: boolean }>`
  border: 0;
  z-index: 9998;
  position: fixed;
  vertical-align: top;
  text-decoration: none;
  right: max(calc(50vw - 600px - 72px), ${({ theme }) => theme.x2spacePx}px);
  bottom: ${({ theme }) => theme.safeAreaInsetBottom};
  transform: ${({ theme }) => `translate(0,-${theme.x17spacePx}px)`};
  transition: opacity 0.5s;
  opacity: ${({ isEnter }) => (isEnter ? 1 : 0)};
  pointer-events: ${({ isEnter }) => (isEnter ? 'auto' : 'none')};

  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const FloatingActionMenuOverlay = styled('div')<{ isEnter: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9997;
  background-color: #000;
  transition: opacity 0.5s;
  opacity: ${({ isEnter }) => (isEnter ? 0.75 : 0)};
  pointer-events: none;
`;

export const FloatingActionMenuRow = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.x1spacePx + 4}px;
`;

export const FloatingActionMenuTitle = styled('div')`
  color: ${({ theme }) => theme.color.white};
  margin-right: ${({ theme }) => theme.x1spacePx + 4}px;
`;
export const MinimalButton = styled(Button)`
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.x7spacePx}px;
  width: ${({ theme }) => theme.x7spacePx}px;
  border-radius: 99999px;
  &&& {
    box-shadow: none;
  }
`;

export const ButtonWrapper = styled('div')`
  margin-top: 4px;
  margin-bottom: 4px;
  button {
    height: ${({ theme }) => theme.x7spacePx}px;
    width: ${({ theme }) => theme.x7spacePx}px;
  }
`;

interface MoreActionsSVGProps {
  open?: boolean;
}

export const MoreActionsSVG = styled(PlusSolid)<MoreActionsSVGProps>`
  transition: transform 0.5s;
  transform: ${({ open }) => `rotate(${open ? 45 : 0}deg)`};
  &&& {
    opacity: 1;
  }
`;

export const ShareSVG = styled(ShareOutline)`
  &&& {
    opacity: 1;
  }
`;

export const AddNoteSVG = styled(EditSolid)`
  &&& {
    opacity: 1;
  }
`;
export const NotesSVG = styled(NotesOutline)`
  &&& {
    opacity: 1;
  }
`;
